import { useId } from 'react'

import { useTranslation } from 'react-i18next'

import { Icon } from '@/Atomic/Atoms/Icon'
import { StringText } from '@/Atomic/Atoms/StringText'
import { Tooltip } from '@/Atomic/Molecules/Tooltip'

import './DisplayCount.scss'

interface DisplayCountProps {
  amount: number
  total: number
  labelKey: string
  showRestrictedHint?: boolean
}

export const DisplayCount: React.FC<DisplayCountProps> = ({
  amount,
  total,
  labelKey,
  showRestrictedHint = false,
}) => {
  const { t } = useTranslation()
  const entityLabel = t(labelKey, { count: total })
  const tooltipAnchorId = `display-count-${labelKey.replace(/[^a-zA-Z0-9_-]/g, '-')}-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`
  const restrictedCountHint = t('tooltip.countRestricted', {
    entity: entityLabel,
  })

  return (
    <div className="m-display-count">
      <StringText
        variant="caption"
        value={`${amount}/${total} ${entityLabel}`}
        wrapperClassName="m-display-count__text-wrapper"
      />
      <span
        id={showRestrictedHint ? tooltipAnchorId : undefined}
        className={`m-display-count__hint${showRestrictedHint ? ' is-visible' : ''}`}
        aria-label={showRestrictedHint ? restrictedCountHint : undefined}
      >
        <Icon icon="info-circle" size="sm" />
      </span>
      {showRestrictedHint && (
        <Tooltip
          anchorSelect={`#${tooltipAnchorId}`}
          place="bottom"
          content={restrictedCountHint}
        />
      )}
    </div>
  )
}
